import {
  RequestRepaymentHolidayHeader,
  RHExtendTermActiveComponent,
  RHNoExtendTermActiveComponent,
} from ".";
import { SelectedTreatmentsDetails } from "domain/selectedTreatments";
import { RepaymentOption } from "domain/indicativeRepaymentOptions";
import { VisibleSection } from "components/common/VisibleSection";
import { Button } from "reactstrap";
import { CreateEnhancer } from "util/enhancer";
import { AboutYourLoan } from "domain/aboutYourLoan";

type RequestRepaymentHolidayProps = {
  repaymentOptions: RepaymentOption[];
  selectedTreatments: SelectedTreatmentsDetails;
  aboutYourLoan: AboutYourLoan;
  extendTermTaken: boolean;
  checked: boolean;
  onClick: () => void;
  onChange: (selectedTreatments: SelectedTreatmentsDetails) => void;
  onChecked: (checked: boolean) => void;
};

const RequestRepaymentHoliday = ({
  aboutYourLoan: { CRHTaken, CIRHTaken },
  repaymentOptions,
  selectedTreatments,
  extendTermTaken,
  checked,
  onClick,
  onChange,
  onChecked,
}: RequestRepaymentHolidayProps) => {
  return (
    <>
      <div className="repaymentOptions stickyLandingContainer">
        <div>
          <RequestRepaymentHolidayHeader />
          <VisibleSection visible={extendTermTaken}>
            <RHExtendTermActiveComponent
              CRHTaken={CRHTaken}
              CIRHTaken={CIRHTaken}
              repaymentOptions={repaymentOptions}
              selectedTreatments={selectedTreatments}
              onChange={onChange}
              checked={checked}
              onChecked={onChecked}
            />
          </VisibleSection>
          <VisibleSection visible={!extendTermTaken}>
            <RHNoExtendTermActiveComponent
              CRHTaken={CRHTaken}
              CIRHTaken={CIRHTaken}
              repaymentOptions={repaymentOptions}
              selectedTreatments={selectedTreatments}
              onChange={onChange}
              checked={checked}
              onChecked={onChecked}
            />
          </VisibleSection>
        </div>
        <div className="button-end">
          <Button
            color="primary"
            size="lg"
            disabled={!selectedTreatments.selectedOptionType || !checked}
            onClick={onClick}
          >
            Next
          </Button>
        </div>
      </div>
    </>
  );
};

const RequestRepaymentHolidayEnhanced = CreateEnhancer<
  RequestRepaymentHolidayProps,
  "repaymentOptions" | "aboutYourLoan"
>((p) => !p.repaymentOptions?.length && !p.aboutYourLoan)(
  RequestRepaymentHoliday
);

export { RequestRepaymentHolidayEnhanced as RequestRepaymentHoliday };
